// extracted by mini-css-extract-plugin
module.exports = {"content":"default_content_2jT-H","buttonRemoveBackground":"default_buttonRemoveBackground_2I1lH"};